import {
  ApplicationState,
  EodStateResponse,
  MessageByKey
} from './application.model';

const reducers = {
  addHtmlContent: (state: ApplicationState, htmlContent: MessageByKey) => {
    const exists = state.htmlContent.some(
      ({ messageKey }) => messageKey === htmlContent.messageKey
    );
    if (!exists) {
      return { ...state, htmlContent: [...state.htmlContent, htmlContent] };
    }
    const newHtmlContentState = state.htmlContent.map((item) =>
      item.messageKey === htmlContent.messageKey ? htmlContent : item
    );
    return {
      ...state,
      htmlContent: newHtmlContentState
    };
  },
  storeAppVersion: (
    state: ApplicationState,
    bffVersion: string,
    adapterVersion: string
  ) => ({
    ...state,
    bffVersion,
    adapterVersion
  }),
  storeSigmaAvailability: (
    state: ApplicationState,
    sigmaAvailable: boolean
  ) => ({
    ...state,
    sigmaAvailable
  }),
  storeEodStatus: (state: ApplicationState, eodState: EodStateResponse) => ({
    ...state,
    eodState: { status: eodState.eodProcessing, date: eodState.businessDate }
  }),
  enableKisaLoginPageVisibility: (state: ApplicationState) => ({
    ...state,
    kisaLoginPageVisibility: true
  }),
  disableKisaLoginPageVisibility: (state: ApplicationState) => ({
    ...state,
    kisaLoginPageVisibility: false
  }),
  enableChatBeforeLogin: (state: ApplicationState, chatAvailable: boolean) => ({
    ...state,
    chatBeforeLoginEnabled: chatAvailable
  }),
  storeContactDetailsFeatureToggle: (
    state: ApplicationState,
    contactDetails: boolean
  ) => ({
    ...state,
    contactDetailsFeatureToggle: contactDetails
  }),
  storeContractDetailsFeatureToggle: (
    state: ApplicationState,
    contractDetails: boolean
  ) => ({
    ...state,
    contractDetailsFeatureToggle: contractDetails
  }),
  storeContractDashboardFeatureToggle: (
    state: ApplicationState,
    contractDetails: boolean
  ) => ({
    ...state,
    contractDashboardFeatureToggle: contractDetails
  }),
  storeConsentsAndObligationsFeatureToggle: (
    state: ApplicationState,
    consentsAndObligations: boolean
  ) => ({
    ...state,
    consentsAndObligationsFeatureToggle: consentsAndObligations
  }),
  disablePayments: (state: ApplicationState) => ({
    ...state,
    payments: { paymentsAvailability: false }
  }),
  setClientSynchroToggle: (state: ApplicationState, toggled: boolean) => ({
    ...state,
    clientSynchroToggle: toggled
  }),
  enablePayments: (state: ApplicationState) => ({
    ...state,
    payments: { paymentsAvailability: true }
  }),
  storeToggleLoading: (state: ApplicationState, isLoading: boolean) => ({
    ...state,
    toggleLoading: isLoading
  }),
  storeDataSynchronized: (
    state: ApplicationState,
    dataSynchronized: boolean | null
  ) => ({
    ...state,
    dataSynchronized
  })
};

export default reducers;
